import apiBase from "../../infra/apiBase";
import api from "../../infra/api";
import AuthHelper from "../../infra/helpers/AuthHelper";

class ServLogin {
  async recuperarImages() {
    const response = await apiBase({
      method: "GET",
      url: "api/v1/Parametros/RecuperarImagensDoPortal"
    });

    return response.data;
  }

  async login(email, senha) {
    const response = await apiBase({
      method: "post",
      url: "/api/v1/Login/Login",
      data: JSON.stringify({ Email: email, Senha: senha }),
    });

    // AuthHelper.setUltimoEmail(email);
    // AuthHelper.setToken(response.data.Content.Token);
    // AuthHelper.setRefreshToken(response.data.refresh_token);

    return response.data;

    // const dataAtual = new Date();
    // dataAtual.setSeconds(dataAtual.getSeconds() + response.data.expires_in);
    // AuthHelper.setValidadeToken(dataAtual.toString());

    //AuthHelper.setCodigoLogin(response.data.Content.CodigoLogin);
  }

  async permissoesModulos() {
    const response = await api({
      method: "GET",
      url: "api/v1/ResponsavelTecnico/PermissoesModulos",
    });

    return response.data;
  }

  async refreshToken() {
    const refreshToken = AuthHelper.getRefreshToken();

    if (!refreshToken) return;

    const response = await apiBase({
      method: "post",
      url: "api/Token",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      data: JSON.stringify({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      }),
    });

    // AuthHelper.setToken(response.data.Content.Token);

    return response;
    //   AuthHelper.setRefreshToken(response.data.Content.refresh_token);

    // const dataAtual = new Date();
    // dataAtual.setSeconds(dataAtual.getSeconds() + response.data.expires_in);
    // AuthHelper.setValidadeToken(dataAtual.toString());
  }

  async recuperarSenha(
    Email
  ) {
    const response = await apiBase({
      method: "post",
      url: "api/v1/Login/RecuperarSenha",
      data: JSON.stringify({
        Email
      }),
    });

    return response.data;
  }

  async cadastrarUsuario(
    Nome,
    Celular,
    Email,
    Senha,
    CPF
  ) {
    const response = await apiBase({
      method: "post",
      url: "api/v1/Login/Cadastrar",
      data: JSON.stringify({
        Nome,
        Celular,
        Email,
        Senha,
        CPF
      }),
    });

    return response.data;
  }

  async redefinirSenha (dto) {
    const response = await apiBase({
      method: "POST",
      url: `api/v1/Login/AlterarSenhaViaEmail`,
      data: JSON.stringify(dto)
    });

    return response.data;
  }

  async continuarCadastro(form) {
    await api({
      method: "post",
      url: "api/v1/ResponsavelTecnico/SolicitarAnaliseDaHabilitacao",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: form,
    });
  }

  async revisarCadastro(form) {
    await api({
      method: "PUT",
      url: "api/v1/ResponsavelTecnico/SolicitarAnaliseDaHabilitacao",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: form,
    });
  }

  async recuperarDadosResponsavel (CodigoResponsavel) {
    const response = await api({
      method: "GET",
      url: `api/v1/ResponsavelTecnico/${CodigoResponsavel}` 
    });

    return response.data;
  }

  async recuperarImagensDoResponsavelTecnico(codigoResponsavel) {
    const response = await api({
      method: "GET",
      url: `api/v1/ResponsavelTecnico/${codigoResponsavel}/RecuperarImagensDoResponsavel` 
    });

    return response.data;
  }

  async recuperarImagensDoResponsavel(codigoResponsavel) {
    const response = await api({
      method: "GET",
      url: `api/v1/ResponsavelTecnico/${codigoResponsavel}/RecuperarImagensDoResponsavel` 
    });

    return response.data;
  }

  async consultaAnaliseResponsavel (CodigoResponsavel) {
    const response = await api({
      method: "GET",
      url: `api/v1/ResponsavelTecnico/${CodigoResponsavel}/ConsultaAnalisandoResponsavel`
    });

    return response.data;
  }

  async salvarEdicao(codigoUsuario, form) {
    await api({
      method: "PUT",
      url: `api/v1/ResponsavelTecnico/${codigoUsuario}`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: form,
    });
  }

  async solicitarNovaHomologacao(codigoUsuario) {
    await api({
      method: "PUT",
      url: `api/v1/ResponsavelTecnico/${codigoUsuario}/SolicitarNovaAnalise`
    });
  }

  async recuperarMotivoDeReprovacao(codigoResponsavel) {
    const response = await api({
      method: "GET",
      url: `api/v1/ResponsavelTecnico/${codigoResponsavel}/RecuperarMotivoDeReprovacao`
    });

    return response.data;
  }

  async alterarSenhaAtual(codigoResponsavel, dto) {
    const response = await api({
      method: "POST",
      url: `api/v1/Login/AlterarSenhaAtual/${codigoResponsavel}`,
      data: JSON.stringify(dto)
    });

    return response.data;
  }

  async recuperarDadosPaginaLogin() {
    const response = await apiBase({
      method: "GET",
      url: "api/v1/Parametros/DadosPaginaLogin"
    });

    return response.data;
  }

  async recuperarCidadePadrao() {
    const response = await api({
      method: "GET",
      url: "api/v1/ResponsavelTecnico/RecuperarCidadePadrao"
    });

    return response.data;
  }
}

export default new ServLogin();
